import { useI18n } from 'vue-i18n'

export default function useSharedTranslations() {
  const { t } = useI18n()

  const typographyPresetTranslations = {
    h_1: t('canvasUI.CRichTextEditor.title'),
    h_2: t('canvasUI.CRichTextEditor.headline'),
    h_3: t('canvasUI.CRichTextEditor.subheading'),
    big_text: t('canvasUI.CRichTextEditor.bigText'),
    normal_text: t('canvasUI.CRichTextEditor.normalText'),
    small_text: t('canvasUI.CRichTextEditor.smallText'),
  }

  return {
    typographyPresetTranslations,
  }
}
